import { useState } from "react"
import PropTypes from "prop-types"
import { isPresent } from "utils/helpers"
import { colors } from "components/shared/admin_colors"

const CapacityField = ({ onChange, selectionType = {}, signupMaxCapacity = "", valid = null }) => {
  const hasSelectionType = isPresent(selectionType)

  const [capacity, setCapacity] = useState(
    hasSelectionType ? selectionType.maximumCapacity ?? "" : signupMaxCapacity
  )

  const handleChange = e => {
    if (Number(e.target.value) >= 0) {
      setCapacity(e.target.value)

      return onChange({
        id: selectionType.id,
        maximum_capacity: e.target.value ? Number(e.target.value) : null
      })
    }

    if (Number(e.target.value) == -1) {
      setCapacity("")
      return onChange({
        id: selectionType.id,
        maximum_capacity: null
      })
    }
  }

  return (
    <div>
      <input
        type="number"
        name={`maximum_capacity-${selectionType.id || "total"}`}
        className={valid ? "error-input" : ""}
        placeholder="unlimited"
        value={capacity ?? ""}
        onChange={handleChange}
        maxLength={9}
        autoComplete="off"
      />
      {valid && (
        <span
          style={{
            fontWeight: "normal",
            fontSize: "12px",
            color: colors.error
          }}
        >
          {valid}
        </span>
      )}
    </div>
  )
}

CapacityField.propTypes = {
  selectionType: PropTypes.shape({ maximumCapacity: PropTypes.number, id: PropTypes.number }),
  signupMaxCapacity: PropTypes.number,
  valid: PropTypes.string,
  onChange: PropTypes.func
}

export default CapacityField
